import React from 'react';

import {Container} from './styles';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  to: string;
  widthMode?: 'expand' | 'fit-content';
  size?: 'small' | 'default';
  permission?: string;
  visible?: boolean;
}

const LinkButton: React.FC<Props> = ({
  title,
  to,
  widthMode = 'fit-content',
  size = 'default',
  permission,
  visible = true,
}) => {
  const {isAllowed} = useAccessControls();
  if ((permission && !isAllowed(permission)) || !visible) return null;

  return (
    <Container to={to} {...{width: widthMode, size}}>
      {title}
    </Container>
  );
};

export default LinkButton;
